import { render, staticRenderFns } from "./TooltipInfoButton.vue?vue&type=template&id=c5212586&scoped=true"
import script from "./TooltipInfoButton.vue?vue&type=script&lang=ts"
export * from "./TooltipInfoButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5212586",
  null
  
)

export default component.exports